import {
  Datagrid,
  TextField,
  BooleanField,
  List,
  Filter,
  SearchInput,
  SelectInput,
} from "react-admin";

const ProjectTeamFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      source="archived"
      label="Archived"
      choices={[
        { id: "false", name: "Not archived" },
        { id: "true", name: "Archived" },
        { id: "all", name: "All" },
      ]}
      alwaysOn
    />
  </Filter>
);

export const ProjectTeamsList = (props) => {
  return (
    <List
      {...props}
      perPage={25}
      sort={{ field: "updated", order: "DESC" }}
      filters={<ProjectTeamFilter />}
      filterDefaultValues={{ archived: "false" }}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="jobFunction" />
        <BooleanField source="archived" />
      </Datagrid>
    </List>
  );
};

export default ProjectTeamsList;
